<template>
	<div>
		<v-card
			id="card"
			class="mt-2"
			:tile="$vuetify.breakpoint.xs"
			:max-width="max_width"
			height="100%"
			elevation="10"
		>
			<v-row gutters class="close-icon" justify="end" @click="$emit('delete-product', index)">
				<i class="fas fa-times-circle"></i>
			</v-row>
			<v-card-title class="pa-0 mb-2">製品：{{ index + 1 }}</v-card-title>
			<v-card-subtitle class="font-weight-bold pa-0 ma-0">カテゴリー</v-card-subtitle>
			<v-card-text class="pa-0 ma-0">{{ product.product_category.name }}</v-card-text>
			<v-card-subtitle class="font-weight-bold pa-0 mt-2">製品名</v-card-subtitle>
			<v-card-text class="pa-0 ma-0">{{ product.name }}</v-card-text>
			<v-text-field
				v-model.trim="product.product_sub_name"
				class="pa-0 mt-2"
				label="寸法などの製品補足"
				@change="changeProduct"
				background-color="white"
				outlined
				dense
				hide-details
			></v-text-field>
			<v-card-subtitle class="font-weight-bold pa-0 mt-2">製品仕様</v-card-subtitle>
			<v-card-text class="pa-0 ma-0">{{ product.specification }}</v-card-text>

			<Datetime
				v-if="contract && contract !== 'nil'"
				v-model="product.start_date"
				class="datetime"
				:minute-interval="5"
				:format="'YYYY-MM-DD HH:mm'"
				:overlay="true"
				:min-date="start"
				:max-date="end"
				label="製造開始予定日時"
				:noLabel="!!product.start_date"
				@is-shown="expandCard"
				@is-hidden="shrinkCard"
			></Datetime>

			<Datetime
				v-if="contract && contract !== 'nil'"
				v-model="product.end_date"
				class="datetime"
				:minute-interval="5"
				:format="'YYYY-MM-DD HH:mm'"
				:overlay="true"
				:min-date="start"
				:max-date="end"
				label="製造終了日時"
				:noLabel="!!product.start_date"
				@is-shown="expandCard"
				@is-hidden="shrinkCard"
			></Datetime>

			<v-card-subtitle class="font-weight-bold pa-0 mt-2 mb-1"
				>単価： {{ Number(product.product_unit_price).toLocaleString() }}円</v-card-subtitle
			>
			<v-text-field
				v-model="product.product_unit_price"
				label="単価"
				class="pa-0 ma-0"
				@change="changeProduct"
				background-color="white"
				outlined
				dense
				hide-details
			></v-text-field>
			<v-card-subtitle class="font-weight-bold pa-0 mt-2 mb-1">
				数量： {{ product.product_quantity }}</v-card-subtitle
			>
			<v-text-field
				v-model="product.product_quantity"
				class="pa-0 ma-0"
				type="number"
				label="数量"
				@change="changeProduct"
				background-color="white"
				outlined
				dense
				hide-details
			></v-text-field>
			<v-divider class="mt-2 mb-2"></v-divider>
			<v-card-subtitle class="font-weight-bold pa-0 ma-0"
				>原価： {{ Number(product.cost_price).toLocaleString() }}円</v-card-subtitle
			>
			<v-card-subtitle class="font-weight-bold pa-0 ma-0"
				>単価あたり粗利：
				{{
					Number(product.product_unit_price - product.cost_price).toLocaleString()
				}}円</v-card-subtitle
			>
			<v-card-subtitle class="font-weight-bold pa-0 ma-0"
				>標準販売価格： {{ Number(product.standard_price).toLocaleString() }}</v-card-subtitle
			>
			<v-card-subtitle class="font-weight-bold pa-0 ma-0"
				>定価：{{ Number(product.list_price).toLocaleString() }}円</v-card-subtitle
			>
		</v-card>
	</div>
</template>

<script>
import Datetime from "vue-ctk-date-time-picker"
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css"
import moment from "moment/min/moment.min.js"

export default {
	components: {
		Datetime,
	},
	props: {
		product: {
			type: Object,
			required: false,
			default: () => {},
		},
		index: {
			type: Number,
			required: false,
		},
		contract: {
			type: [String, Boolean],
		},
	},
	data() {
		return {}
	},
	methods: {
		changeProduct() {
			this.$emit("change-product", this.product)
		},
		expandCard() {
			const card = document.getElementById("card")
			card.style.height = "850px"
		},
		shrinkCard() {
			const card = document.getElementById("card")
			card.style.height = "auto"
		},
	},
	computed: {
		max_width() {
			if (this.$vuetify.breakpoint.xs) {
				return "300"
			} else {
				return "265"
			}
		},
		start() {
			// min-date に明日の9時を指定
			const start = moment().add(1, "days").hour(8)
			return start.format("YYYY-MM-DDTHH:mm:ss")
		},
		end() {
			// max-date に min-date から3ヶ月後を指定
			const start = moment(this.start)
			const end = start.add(3, "months").endOf("day")
			return end.format("YYYY-MM-DDTHH:mm:ss")
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.close-icon {
	margin: 10px 20px 0 0;
	i {
		cursor: pointer;
		margin-top: 10px;
	}
}
.v-card {
	background-color: #d2dbd7;
	margin: 10px;
	padding: 17px;
}
.field-input {
	border: solid 1px #a8a8a8 !important;
	box-shadow: none !important;
}

.date-time-picker {
	@media (min-width: $xs) {
		width: 100% !important;
		margin-bottom: 20px !important;
	}
}
</style>
